<template>
	<carousel :autoplay="5000" :items-to-show="1" :pauseAutoplayOnHover="true" :transition="400" :wrapAround="true">
		<EventSlide v-for="item in events" :key="item.id" :event="item"></EventSlide>
		<template #addons>
			<navigation/>
		</template>
	</carousel>
</template>

<script lang="ts" setup>
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Navigation} from 'vue3-carousel'
import {CartEventInterface} from "@/js/interfaces/event"
import EventSlide from "@/js/components/elements/eventSlider/EventSlide.vue"

defineProps<{
	events: CartEventInterface[]
}>()
</script>

<style scoped>
.std li {
	margin-left: 0;
}
</style>
